import { ChevronDown, ChevronUp, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavItemProps {
  label: string;
  icon: LucideIcon;
  badge?: number;
  isActive?: boolean;
  isExpanded?: boolean;
  isCollapsed?: boolean;
  hasSubItems?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}

export function NavItem({
  label,
  icon: Icon,
  badge,
  isActive = false,
  isExpanded = false,
  isCollapsed = false,
  hasSubItems = false,
  onClick,
  children
}: NavItemProps) {
  return (
    <>
      <button
        onClick={onClick}
        className={cn(
          'w-full flex items-center gap-3 px-2 py-2 rounded-md transition-colors text-sm',
          'hover:bg-accent hover:text-accent-foreground',
          isActive && 'bg-accent text-accent-foreground font-medium',
          !isActive && 'text-foreground/80',
          !hasSubItems && 'mt-1'
        )}>
        <Icon className="w-4 h-4 shrink-0" />
        {!isCollapsed && (
          <>
            <span className="flex-1 text-left truncate">{label}</span>
            {badge && badge > 0 && (
              <span className="bg-destructive text-destructive-foreground px-1.5 py-0.5 text-xs rounded-full">
                {badge}
              </span>
            )}
            {hasSubItems && (isExpanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />)}
          </>
        )}
      </button>

      {!isCollapsed && hasSubItems && isExpanded && children && <ul className="mt-1 ml-4 pl-2">{children}</ul>}
    </>
  );
}
